<abs-modals-and-alerts-component [(modalAction)]="openModal"  (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="pending-cancel-modal-popup">
    <main class="modal-header" tabindex="0">
      <h1 style="display:none;"></h1>
      <h2 id="pending-cancel-modal-container-heading">{{cfetLabels.cfet_verification_pending_utf_modal.heading}}</h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </main>
    <section class="modal-body" id="confirmation-buttons-section" modal-content tabindex="0" >
      <div id="modal-desc">
        <p id="description">{{cfetLabels.cfet_verification_pending_utf_modal.sub_point1}}</p>
        <p id="description">{{cfetLabels.cfet_verification_pending_utf_modal.sub_point2}}</p>
        <p id="description">{{cfetLabels.cfet_verification_pending_utf_modal.sub_point3}}</p>
        <p id="description">{{cfetLabels.cfet_verification_pending_utf_modal.sub_point4}}</p>
        <p id="description" [innerHTML]="cfetLabels.cfet_verification_pending_utf_modal.sub_point5"></p>
      </div>
      <div class="row no-gutters" id="confirmation-buttons">
        <div class="col-md-6">
          <button type="button" id="btn-stay" (click)="cancelApplication($event,'openModal')" (keyup)="cancelApplication($event,'openModal')"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.utf_cancel_application}}</button>
        </div>
        <div class="col-md-6">
          <button type="button" id="btn-cancel" (click)="close($event,'openModal')"
            (keyup)="close($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0"><em
              aria-label=""></em>
            {{cfetButtonLabels.button_labels.stay}}</button>
        </div>
      </div>
    </section>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>